import OliverText from "@builder/components/general/OliverText";
import SimpleCheckbox from "@builder/components/general/SimpleCheckbox";
import TextInput from "@builder/components/general/TextInput";
import Toggle from "@builder/components/general/Toggle";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ActionType } from "@common/build/types";
import { useEffect, useState } from "react";

const AddCartFee = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const [isFixed, setFixed] = useState(actionStep?.action?.data.isFixed || false);
    const [isPercent, setPercent] = useState<boolean>(actionStep?.action?.data.isPercent || false);
    const [feeLabel, setLabel] = useState<string>(actionStep?.action?.data.feeLabel || "");
    const [feeAmount, setAmount] = useState<string>(actionStep?.action?.data.feeAmount || "");
    const [applyTaxes, setApplyTaxes] = useState<boolean>(actionStep?.action?.data.applyTaxes || false);
    const dispatch = useAppDispatch();

    const handleAmount = (value: string) => {
        if (isPercent) {
            if (/^\d*$/.test(value) && Number(value) >= 0 && Number(value) <= 100) {
                setAmount(value);
            }
        } else {
            if (/^\d*\.?\d{0,2}$/.test(value)) {
                setAmount(value);
            }
        }
    };

    const handleToggle = () => {
        setPercent(prev => !prev);
        setAmount("");
    };

    useEffect(() => {
        const data = isFixed ? { isPercent, feeAmount, feeLabel, applyTaxes } : undefined;
        const action = {
            type: isFixed ? ActionType.CART_ADD_FEE : ActionType.SHOW_ADD_CUSTOM_FEE_UI,
            data: { isFixed, ...data }
        };

        const updatedStep = { ...actionStep };
        updatedStep.action = { ...action };

        if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
            dispatch(updateStepperActions({ id: id as string, item: updatedStep as ActionEditorItem }));
        }
    }, [actionStep, dispatch, id, isFixed, isPercent, feeAmount, feeLabel, applyTaxes]);

    return (
        <div className="function-add-cart-note-wrapper">
            <OliverText text="How do you want to add the fee?" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
            <div className="function-add-cart-note">
                <div className="function-checkbox-wrapper" onClick={() => setFixed(false)}>
                    <div className="function-checkbox-label-wrapper">
                        <OliverText text="Open cart fee input box" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                        <OliverText text="This will open the cart fee pop up" size="xs" weight="light" translatePrefix="popup.actionBuilder." />
                    </div>
                    <SimpleCheckbox callback={() => {}} checked={!isFixed} label="" value="" custom={false} />
                </div>
                <div className="function-checkbox-wrapper" onClick={() => setFixed(true)}>
                    <div className="function-checkbox-label-wrapper">
                        <OliverText text="Fixed cart fee" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                        <OliverText
                            text="This will automatically add a fixed fee to the cart"
                            size="xs"
                            weight="light"
                            translatePrefix="popup.actionBuilder."
                        />
                    </div>
                    <SimpleCheckbox callback={() => {}} checked={isFixed} label="" value="" custom={false} />
                </div>
                {isFixed ? (
                    <>
                        <div className="function-add-cart-note-wrapper">
                            <TextInput callback={setLabel} value={feeLabel} className="actions-tab-input" placeholder="Description" />
                            <TextInput
                                callback={handleAmount}
                                value={feeAmount}
                                className="actions-tab-input"
                                placeholder="Amount"
                                icon={{
                                    src: ["./dollar-sign.svg", "./percentage-sign.svg"],
                                    callback: (event: React.MouseEvent) => {
                                        event.preventDefault();
                                        handleToggle();
                                    }
                                }}
                                isPercent={isPercent}
                            />
                        </div>
                        <div className="function-checkbox-wrapper">
                            <div className="function-checkbox-label-wrapper">
                                <OliverText text="Apply taxes" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                                <OliverText
                                    text="Fixed cart fees use the standard tax class"
                                    size="xs"
                                    weight="light"
                                    translatePrefix="popup.actionBuilder."
                                />
                            </div>
                            <div style={{ width: "fit-content" }}>
                                <Toggle callback={() => setApplyTaxes(prev => !prev)} checked={applyTaxes} label="" />
                            </div>
                        </div>
                    </>
                ) : null}
            </div>
        </div>
    );
};

export default AddCartFee;
